import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import {withFormik} from "formik";
import React from "react";
import ScrollDialog from "./../components/dialog/ScrollDialog";
import UserService from "./UserService";
import SignIn from "../components/SignIn";

const defaultLoginErrorMsg = [
    "El usuario y/o contraseña ingresados son incorrectos. ",
    <br/>,
    <br/>,
    "Por favor, verifique los datos e intente nuevamente.",
    <br/>,
    <br/>,
    "Si necesita solicitar que la clave sea modificada debe enviar un mail a admseg@tgs.com.ar"
];

const Form = ({
                  handleSubmit,
                  handleChange,
                  values,
                  errors,
                  isValid,
                  isSubmitting,
                  onSignIn
              }) => (
    <Grid className="loginWrapper" container>
        <Grid className="background" item md={8}/>
        <Grid className="login" item md={4}>
            <div className="logotgs"/>
            <div className="loginInputs">
                {process.env.REACT_APP_MFA == undefined ? (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <TextField
                            className="input"
                            name="userName"
                            type="text"
                            value={values.userName || ""}
                            onChange={handleChange}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">Usuario</InputAdornment>
                                )
                            }}
                        />
                        <div className="errorLogin">{errors.userName}</div>
                        <TextField
                            className="input"
                            name="password"
                            type="password"
                            value={values.password || ""}
                            onChange={handleChange}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">Contraseña</InputAdornment>
                                )
                            }}
                        />
                        <div className="errorLogin">{errors.password}</div>
                        <div className="botones">
                            <Button
                                size="large"
                                color="primary"
                                className="button"
                                disabled={!isValid || isSubmitting}
                                type="submit"
                            >
                                ACEPTAR
                            </Button>
                            <Button size="large" color="primary" className="button">
                                CANCELAR
                            </Button>
                        </div>
                    </form>)
                    :
                    (<SignIn onSignIn={onSignIn} />)
                }
            </div>
            <div className="masInfo">
            {process.env.REACT_APP_MFA && (<ScrollDialog/>)}
            </div>
        </Grid>
    </Grid>
);

const Login = ({history, location, loginSuccess, showDialog, loginErrorMsg}) => {
    const validateForm = ({userName, password}) => {
        const errors = {};
        if (userName && userName.length < 3)
            errors.userName = "Nombre de usuario requerido.";
        if (password && password.length < 3)
            errors.password = "Contraseña requerida";
        return errors;
    };

    const handleSignIn = (response) => {

        if(typeof response !== "undefined" && response !== null){
            loginSuccess(response);
            if (location.state === "/" && location.state.isInternalRedirect) {
                history.goBack();
            } else {
                history.push("/");
            }

        }
    }

    const login = async ({userName, password}, {setSubmitting}) => {

        try {
            const user = await UserService.login(userName, password);
            if (user) {
                await UserService.validatePermisos();

                loginSuccess(user);
                // Correción de la condición. Cuando no tenía historial no habia a donde hacer el goBack..
                if (location.state === "/" && location.state.isInternalRedirect) {
                    history.goBack();
                } else {
                    history.push("/");
                }

            }
        } catch (error) {
            //console.log(error);
            if (error.status === 409) {
                loginErrorMsg([error.data.message]);
            } else {
                loginErrorMsg(defaultLoginErrorMsg);
            }
            showDialog(true);
            setSubmitting(false);
            //console.error(error);
        }

        /*
        UserService.login(userName, password)
          .then(user => {
            loginSuccess(user);
            // Correción de la condición. Cuando no tenía historial no habia a donde hacer el goBack..
            if (location.state === "/" && location.state.isInternalRedirect) {
              history.goBack();
            } else {
              history.push("/");
            }
          })
          .catch(error => {
            showDialog(true);
            setSubmitting(false);
            //console.error(error);
          });*/
    };

    const formikConf = {
        displayName: "LoginForm",
        validate: validateForm,
        handleSubmit: login
    };

    const Frm = withFormik(formikConf)(Form);

    return (
        <div>
            <Frm onSignIn={handleSignIn}/>;
        </div>
    );
};

export default Login;
